export const getUser = state => state.user.user;
export const getUsers = state => state.user.users;
export const getLeaUsers = state => state.user.leaUsers;
